import type { IInboxEntry } from './IInboxEntry';
import type { InboxKind } from './InboxKind';

/** Колір і знак виду (прототип v4 STYLE): доручення #1f4ebc «A», нагадування #c2410c «!», коментар #6b3fd1 «“», оновлення #1f8a5b «i». */
const STYLE: Record<InboxKind, [string, string]> = {
  assignment: ['#1f4ebc', 'A'], reminder: ['#c2410c', '!'], comment: ['#6b3fd1', '“'], update: ['#1f8a5b', 'i'],
};

/** Тон і знак кружка рядка вхідних; прострочене нагадування — #b91c1c. */
export function inboxTone(entry: IInboxEntry): { tone: string; glyph: string } {
  const [tone, glyph] = STYLE[entry.kind];
  return { tone: entry.late ? '#b91c1c' : tone, glyph };
}
